export default __webpack_public_path__ + "static/media/mystrybox_alt.4bb60c6e.png";